/**
 * TIROIR PANIER — ventes additionnelles : choix de la taille puis « Ajouter au panier » dans la carte
 * --------------------------------------------------------------------------
 * Produit à tailles : tailles + bouton « Ajouter au panier » visibles, 1re taille dispo
 * présélectionnée (Liquid). Le tap sur une autre taille la SÉLECTIONNE ; le bouton soumet
 * le <product-form> natif → ajout + re-rendu du tiroir par le thème. (Le dépliage
 * [data-cart-upsell-toggle] n'est plus utilisé ; gardé, inoffensif.) Écoute déléguée : le
 * tiroir est re-rendu à chaque changement de panier.
 */
(function () {
  if (window.__cartUpsellInit) return;
  window.__cartUpsellInit = true;

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest && e.target.closest('[data-cart-upsell-toggle]');
    if (!toggle) return;
    e.preventDefault();

    var card = toggle.closest('.cart-upsell-card');
    var sizes = card && card.querySelector('.cart-upsell-card__sizes');
    if (!sizes) return;

    var open = sizes.hidden;
    sizes.hidden = !open;
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  // Tap sur une taille = SÉLECTION (pas d'ajout) : taille soulignée, input « id » mis à
  // jour, bouton « Ajouter au panier » activé. C'est le bouton qui ajoute.
  document.addEventListener('click', function (e) {
    var size = e.target.closest && e.target.closest('[data-upsell-size]');
    if (!size || size.disabled) return;
    var card = size.closest('.cart-upsell-card');
    if (!card) return;
    e.preventDefault();

    card.querySelectorAll('[data-upsell-size]').forEach(function (b) {
      var on = b === size;
      b.classList.toggle('is-selected', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    var input = card.querySelector('[data-upsell-variant-input]');
    if (input) input.value = size.getAttribute('data-variant-id');
    var cta = card.querySelector('.cart-upsell-card__cta');
    if (cta) {
      cta.disabled = false;
      cta.textContent = cta.getAttribute('data-label-add');
    }
  });
})();
